module.exports = __webpack_public_path__ + "media/stylesheets/images/main/sample224x246-771a56a227e05ce7d16f386167eec51c.jpeg";